function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
import scrollTop from './utils';
import { buildComponentName } from '../utils';
var anchorRegex = /^\S+[^/](#\S+)$/;
var __vue_script__ = {
  name: buildComponentName('Anchor'),
  provide: function provide() {
    return {
      anchor: this
    };
  },
  props: {
    prefixCls: {
      type: String,
      default: 'ux-anchor'
    },
    offsetTop: {
      type: Number,
      default: 0
    },
    showInk: {
      type: Boolean,
      default: true
    },
    getContainer: {
      type: Function,
      default: function _default() {
        return null;
      }
    },
    bounds: {
      type: Number,
      default: 5
    },
    beforeHashChange: {
      type: Function,
      default: function _default() {
        return true;
      }
    },
    beforeScroll: {
      type: Function,
      default: function _default() {
        return true;
      }
    }
  },
  data: function data() {
    return {
      currentLink: '',
      // #title1
      oldScrollTop: 0,
      newScrollTop: 0,
      titles: []
    };
  },
  computed: {
    inkBallClasses: function inkBallClasses() {
      var _ref;

      var prefixCls = this.prefixCls,
          showInk = this.showInk;
      return _ref = {}, _defineProperty(_ref, "".concat(prefixCls, "-ink-ball"), true), _defineProperty(_ref, "visible", showInk), _ref;
    },
    currentId: function currentId() {
      if (this.currentLink !== '') {
        return this.currentLink.substring(1);
      }

      return '';
    },
    inkTop: function inkTop() {
      var initTop = 11;
      var stepHeight = 28;
      var titles = this.titles,
          currentLink = this.currentLink;

      if (currentLink === '') {
        return initTop;
      }

      for (var i = 0; i < titles.length; i++) {
        if (titles[i] === currentLink) {
          return initTop + i * stepHeight;
        }
      }
    },
    scrollContainer: function scrollContainer() {
      var getContainer = this.getContainer;
      return getContainer() || window;
    },
    scrollElement: function scrollElement() {
      var getContainer = this.getContainer,
          scrollContainer = this.scrollContainer;
      return getContainer() ? scrollContainer : document.documentElement || document.body;
    },
    wrapperTop: function wrapperTop() {
      var scrollContainer = this.scrollContainer,
          scrollElement = this.scrollElement;
      return scrollContainer === window ? 0 : scrollElement.offsetTop;
    }
  },
  watch: {
    getContainer: function getContainer() {
      this.init();
    }
  },
  created: function created() {
    var _this = this;

    this.$nextTick(function () {
      _this.init();
    });
  },
  beforeDestroy: function beforeDestroy() {
    this.removeListener();
  },
  methods: {
    handleHashChange: function handleHashChange(href) {
      if (!href) {
        var url = decodeURI(window.location.href);
        var sharpLinkMatch = anchorRegex.exec(url);
        if (!sharpLinkMatch) return;

        var _sharpLinkMatch = _slicedToArray(sharpLinkMatch, 2);

        this.currentLink = _sharpLinkMatch[1];
      } else {
        this.currentLink = href;
      }
    },
    handleScrollTo: function handleScrollTo() {
      var _this2 = this;

      var anchor = document.getElementById(this.currentId);
      if (!anchor) return;
      var top = anchor.offsetTop;
      var cur = anchor.offsetParent;

      while (cur) {
        top += cur.offsetTop;
        cur = cur.offsetParent;
      }

      var offsetTop = top - this.wrapperTop - this.offsetTop;
      this.animating = true;
      scrollTop(this.scrollContainer, this.scrollElement.scrollTop, offsetTop, 600, function () {
        _this2.animating = false;
      });
    },
    addListener: function addListener() {
      this.scrollContainer.addEventListener('scroll', this.scrollListener);
    },
    removeListener: function removeListener() {
      this.scrollContainer.removeEventListener('scroll', this.scrollListener);
    },
    updateTitlesOffset: function updateTitlesOffset() {
      var scrollElement = this.scrollElement,
          titles = this.titles;
      var offsets = [];
      titles.map(function (title) {
        var elm = document.getElementById(title.substring(1));

        if (elm) {
          var top = elm.offsetTop;
          var cur = elm.offsetParent;

          while (cur) {
            top += cur.offsetTop;
            cur = cur.offsetParent;
          }

          offsets.push({
            link: title,
            offset: top - scrollElement.offsetTop
          });
        }
      });
      return offsets;
    },
    scrollListener: function scrollListener() {
      var updateTitlesOffset = this.updateTitlesOffset,
          bounds = this.bounds,
          scrollElement = this.scrollElement,
          offsetTop = this.offsetTop;
      var elmOffsets = updateTitlesOffset();
      var scrollTop = scrollElement.scrollTop + offsetTop;
      scrollTop += bounds;
      var i = -1;

      while (++i < elmOffsets.length) {
        var currentEle = elmOffsets[i];
        var nextEle = elmOffsets[i + 1];

        if (scrollTop >= currentEle.offset && scrollTop < (nextEle && nextEle.offset || Infinity)) {
          this.currentLink = elmOffsets[i].link;
          break;
        }
      }
    },
    init: function init() {
      var _this3 = this;

      this.handleHashChange();
      this.$nextTick(function () {
        _this3.removeListener();

        _this3.addListener();

        if (_this3.beforeScroll(_this3.currentLink)) {
          _this3.handleScrollTo();
        }
      });
    }
  }
};
/* template */

var __vue_render__ = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    class: _vm.prefixCls + "-wrapper"
  }, [_c('div', {
    class: _vm.prefixCls
  }, [_c('div', {
    class: _vm.prefixCls + "-ink"
  }, [_c('span', {
    class: _vm.inkBallClasses,
    style: "top: " + _vm.inkTop + "px;"
  })]), _c('div', {
    class: _vm.prefixCls
  }, [_vm._t("default")], 2)])]);
};

var __vue_staticRenderFns__ = [];
/* style */

var __vue_inject_styles__ = undefined;
/* scoped */

var __vue_scope_id__ = undefined;
/* module identifier */

var __vue_module_identifier__ = undefined;
/* functional template */

var __vue_is_functional_template__ = false;
/* component normalizer */

function __vue_normalize__(template, style, script, scope, functional, moduleIdentifier, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
  var component = (typeof script === 'function' ? script.options : script) || {}; // For security concerns, we use only base name in production mode.

  component.__file = "anchor.js";

  if (!component.render) {
    component.render = template.render;
    component.staticRenderFns = template.staticRenderFns;
    component._compiled = true;
    if (functional) component.functional = true;
  }

  component._scopeId = scope;

  if (false) {
    var hook;

    if (false) {
      // In SSR.
      hook = function hook(context) {
        // 2.3 injection
        context = context || // cached call
        this.$vnode && this.$vnode.ssrContext || // stateful
        this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext; // functional
        // 2.2 with runInNewContext: true

        if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
          context = __VUE_SSR_CONTEXT__;
        } // inject component styles


        if (style) {
          style.call(this, createInjectorSSR(context));
        } // register component module identifier for async chunk inference


        if (context && context._registeredComponents) {
          context._registeredComponents.add(moduleIdentifier);
        }
      }; // used by ssr in case component is cached and beforeCreate
      // never gets called


      component._ssrRegister = hook;
    } else if (style) {
      hook = shadowMode ? function (context) {
        style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
      } : function (context) {
        style.call(this, createInjector(context));
      };
    }

    if (hook !== undefined) {
      if (component.functional) {
        // register for functional component in vue file
        var originalRender = component.render;

        component.render = function renderWithStyleInjection(h, context) {
          hook.call(context);
          return originalRender(h, context);
        };
      } else {
        // inject component registration as beforeCreate hook
        var existing = component.beforeCreate;
        component.beforeCreate = existing ? [].concat(existing, hook) : [hook];
      }
    }
  }

  return component;
}
/* style inject */

/* style inject SSR */

/* style inject shadow dom */


var __vue_component__ = __vue_normalize__({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, undefined, undefined, undefined);

export default __vue_component__;